<template>
  <!-- 6-3-2 医疗机构查看岗位消息 回复消息 -->
  <div class="main-css">
    <!-- 头部 信息显示 -->
    <div class="top-title">
      <div class="top-name">{{$t("medicalInstitution")}}　{{jobInfoData.medicalName}}</div>
      <div class="case-num">　{{$t("recruiter")}}{{jobInfoData.userName}}</div>
      <div class="case-num">　{{$t("caseNumber")}}{{jobInfoData.jobId}}</div>
    </div>
    <!-- 主要信息部分 -->
    <div class="main-box">
      <!-- 左边 -->
      <div class="left-box">
        <!-- 主要信息部分 -->
        <div class="main-left-box">
          <!-- 案件名 -->
          <div class="case-name">
            <div class="title">{{$t('projectTitle')}}</div>
            <p class="title-name">{{jobInfoData.jobName}}</p>
          </div>
          <!-- 显示图片 -->
          <div class="case-img">
            <img :src="imgList1" alt="" />
            <img :src="imgList2" alt="" />
            <img :src="imgList3" alt="" />
          </div>
          <!-- 标签部分 -->
          <div class="label">
            <div class="label-box" v-if="jobInfoData.label1 == 1">{{$t('foreignersWelcome')}}<span>×</span></div>
            <div class="label-box" v-if="jobInfoData.label2 == 1">{{$t('inexperiencedOK')}}<span>×</span></div>
            <div class="label-box" v-if="jobInfoData.label3 == 1">{{$t('newGraduateOK')}}<span>×</span></div>
            <div class="label-box" v-if="jobInfoData.label4 == 1">{{$t('educationalBackgroundMatter')}}<span>×</span></div>
          </div>
          <!-- 第一行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{$t('occupationCategory')}}</div>
              <div class="inline-left-title-main">{{jobInfoData.workType}}</div>
            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{$t('workLocation')}}</div>
              <div class="inline-left-title-main">{{jobInfoData.workSpace}}</div>
            </div>
          </div>
          <!-- 第二行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{$t('employmentForm')}}</div>
              <div class="inline-left-title-main">
                <span v-if="jobInfoData.employmentForm1 == 1">{{$t('fullTimeEmployee')}}</span>
                <span v-if="jobInfoData.employmentForm2 == 1">{{$t('partTimeJob')}}</span>
                <span v-if="jobInfoData.employmentForm3 == 1">{{$t('specificSkill')}}</span>
                <span v-if="jobInfoData.employmentForm4 == 1">{{$t('technicalInternTrainee')}}</span>

              </div>
            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{$t('dutyTime')}}</div>
              <div class="inline-left-title-main">{{jobInfoData.workTime}}</div>
            </div>
          </div>
          <!-- 第三行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{$t('salary')}}</div>
              <div class="inline-left-title-main">{{jobInfoData.hourSalary}} <span style="margin-left: 10px">{{ jobInfoData.startSalary }}~{{ jobInfoData.endSalary }}</span></div>
            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{$t('numberOfHires')}}</div>
              <div class="inline-left-title-main">{{jobInfoData.recruitNumber}}</div>
            </div>
          </div>
          <!-- 第四行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{$t('recruiter')}}</div>
              <div class="inline-left-title-main">{{jobInfoData.userName}}</div>
            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{$t('targetRecruitmentTime')}}</div>
              <div class="inline-left-title-main">{{jobInfoData.principalTime}}</div>
            </div>
          </div>
          <!-- 第五行 -->
          <div class="inline-log-box">
            <div class="long-box-title">{{$t('workContent')}}</div>
            <div class="long-box-main">
              {{jobInfoData.workContent}}
            </div>
          </div>
          <!-- 第六行 -->
          <div class="inline-log-box">
            <div class="long-box-title">{{$t('welfare')}}</div>
            <div class="long-box-main">
              {{jobInfoData.welfareTreatment}}
            </div>
          </div>
          <!-- 第七行 -->
          <div class="inline-log-box">
            <div class="long-box-title">{{$t('employmentConditions')}}</div>
            <div class="long-box-main">
              {{jobInfoData.employmentConditions}}
            </div>
          </div>
          <!-- 第八行 -->
          <div class="inline-log-box">
            <div class="long-box-title">{{$t('other')}}</div>
            <div class="long-box-main">
              {{jobInfoData.other}}
            </div>
          </div>
        </div>
      </div>
      <!-- 右边聊天部分 -->
      <div class="right-box">
        <Socket></Socket>
        <button class="button-css" @click="handleFinalClick">{{$t("collection")}}</button>
      </div>
    </div>
  </div>
</template>
<script>
import Socket from "../../components/socket.vue";
import {educationInfoQuery, getUrlFromOSS, insertMedicalCollection, selectJobDetailInfo} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";
export default {
  name: "educationViewJobInformation",
  components: { Socket },
  data() {
    return {
      jobId:"",
      jobInfoData:[],
      imgList1:"",
      imgList2:"",
      imgList3:""

    };
  },
  created() {
   // this.jobId=this.$route.params.jobId;
    this.jobId="00llef05d6c711ecbac800ffd1723a85"
    this.getSelectJobDetailInfo();
  },
  computed: {},
  methods: {
    //お気に入り按钮
    handleFinalClick(){
      var fakeInfo = {
        systemEventId: this.jobId,
        systemTypeId: 4,
      }
      insertMedicalCollection(fakeInfo).then((res) => {
        console.log("医疗机构新增收藏接口")
        console.log(res)
        if(res.data.code === "A0000"){
          this.$message({
            message: '收藏成功！',
            type: 'success'
          });
          this.$router.push({
            path: '/medicalFavouritesEducationalInstitutionsViewList',
            name: 'medicalFavouritesEducationalInstitutionsViewList',
            params: {
            }
          });
        } else if (res.data.code === "A0506"){
          this.$message({
            message: '该案件已被收藏！',
            type: 'warning'
          });
        } else {
          this.$message.error('提交错误！');
        }
      }).catch((res) => {
        console.log("医疗机构新增收藏接口异常", res)
      })

    },
    //图片回显
    getUrlList(url,number){
      console.log("url"+url+number);
      var fakeInfo={
        message: url
      }
      getUrlFromOSS(fakeInfo).then((res) => {
        if (res.data.code === "200 OK") {
          console.log("图片回显接口1");
          console.log(res);
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          console.log(aesFecInfo);
          if(number == 0){
            this.imgList1=aesFecInfo.message;
          }else if(number == 1){
            this.imgList2=aesFecInfo.message;
          }else if(number == 2){
            this.imgList3=aesFecInfo.message;
          }
        }else{
          console.log(res);
        }
      }).catch(() => {
      })
    },
    //求人信息详情查看接口
    getSelectJobDetailInfo() {
      var fakeInfo = {
      jobId:this.jobId
      }
      selectJobDetailInfo(fakeInfo).then((res) => {
        console.log("求人信息详情查看接口数据", res)
        const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
        console.log(aesFecInfo)
        this.jobInfoData=aesFecInfo
        this.getUrlList(this.jobInfoData.jobPhoto1,0);
        this.getUrlList(this.jobInfoData.jobPhoto1,1);
        this.getUrlList(this.jobInfoData.jobPhoto1,2);
      }).catch((res) => {
        console.log("求人信息详情查看接口数据异常", res)
      })
    },
  },
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.top-title {
  height: 40px;
  width: 92.5%;
  padding: 0 20px;
  margin-left: 2.5%;
}
.top-name {
  padding: 0 50px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-top: 10px;
  float: left;
}
.case-num {
  padding: 0 10px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-top: 10px;
  float: right;
  margin-left: 5px;
}
.main-box {
  width: 1400px;
  margin-top: 20px;
  margin-left: 250px;
  flex: 1;
  padding-top: 10px;
  box-sizing: border-box;
  overflow: hidden;
}
.left-box {
  width: 550px;
  height: 650px;
  float: left;
  overflow: hidden;
  padding-bottom: 20px;
}
.main-left-box {
  width: 568px;
  padding-right: 18px;
  height: 650px;
  overflow-y: scroll;
}
.left-button {
  width: 100%;
  height: 41px;
}
.left-button-1 {
  width: 85px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #51abff;
  float: right;
  margin-left: 5px;
}
.left-button-2 {
  width: 152px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  float: right;
  margin-left: 5px;
}
.case-name {
  height: 55px;
  width: 100%;
}
.case-name .title {
  width: 440px;
  height: 25px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
  border-bottom: 1px solid #686868;
}
.case-name .title-name {
  height: 30px;
  width: 440px;
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  color: #686868;
}
.case-img {
  margin-top: 40px;
  width: 100%;
  height: 114px;
  display: flex;
  justify-content: space-between;
}
.case-img img {
  width: 150px;
  height: 114px;
}
.label {
  width: 100%;
  height: 26px;
  margin-top: 20px;
}
.label-box {
  padding: 0 5px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  float: left;
  margin-right: 20px;
}
.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}
.inline-left {
  width: 200px;
  height: 80px;
  margin-right: 45px;
  float: left;
}
.inline-right {
  width: 240px;
  height: 80px;
  margin-right: 45px;
  float: left;
}
.inline-left-title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}
.inline-left-title-main {
  height: 50px;
  line-height: 50px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
}
.inline-box {
  height: 80px;
  width: 100%;
  margin-top: 10px;
}
.inline-log-box {
  margin-top: 10px;
  width: 100%;
  height: 150px;
}
.long-box-title {
  height: 30px;
  line-height: 30px;
  width: 485px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}
.long-box-main {
  width: 485px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}
.right-box {
  width: 600px;
  height: 700px;
  float: left;
  margin-left: 80px;
}
.button-css {
  width: 150px;
  height: 40px;
  margin-left: -170px;
  background: #fc630c;
  border-radius: 4px;
  box-sizing: border-box;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/medicalJobInformationReply/index.vue